
<div class="lg:px-5 px-2 my-2 ">
  @if (question.QuestionTypeID!=6) {
    <div class="border-b-[1px] border-solid border-grey-500 ">
      @if (question.QuestionTypeID !=8) {
        <div class="flex justify-between py-2 lg:flex-row flex-col ">
          @if (!isCompliant()) {
            <div
              class="bg-danger-base rounded-full text-standardwhite px-4 lg:hidden mb-3 text-center print-hidden">
              <span class="">Not Compliant</span>
            </div>
          }
          <div class=" lg:w-3/5 w-full print-no-break">
            <div class="flex px-2 ">
              <p class="text-green-700 mr-2 font-bold">Q</p>
              <div>
                <p class="font-bold">{{question.QuestionHeader}}</p>
                <p class="">{{question.QuestionBody}}</p>
              </div>
            </div>
            <div class="hidden print-block  font-bold -ml-5 -mt-6  min-h-10" [ngClass]="{'text-danger-base':!isResolved(),'text-green-400':isResolved()}">@if (!isCompliant()) {
              <span class="material-symbols-outlined" >warning</span>
              }@if (isCompliant()) {
              <span ></span>
            }</div>
            <div class="flex mt-2 px-2 -print-mt-3">
              <p class="text-green-400 mr-2 font-bold">A</p>
              <p>{{question.QuestionResult}}</p>
            </div>
            @if (question.QuestionComments.length>0) {
              <div class="mx-5 mt-3 p-2 border-solid border-[1px] border-grey-500 rounded-md bg-grey-100 px-2  print-remove-border  print-mt-1"
                >
                <p class="text-green-700 print-text-xs">Comments</p>
                <p class="italic  print-text-xs">{{question.QuestionComments}}</p>
              </div>
            }
          </div>
          <div class="flex flex-col "
            [ngClass]="{'justify-between':question.MaxScore>0,'justify-end':!isCompliant()}">
            @if (!isCompliant()) {
              <div class="bg-danger-base rounded-full text-standardwhite px-4 lg:block hidden">
                <span class="text-sm">Not Compliant</span>
              </div>
            }
            <div class="flex justify-end mt-4 print-hidden">
              <div class="flex">
              <span
                [ngClass]="{'text-green-400 cursor-pointer':question.QuestionAttachments.length>0,'text-grey-500 cursor-not-allowed':question.QuestionAttachments.length<=0}"
                class="material-symbols-outlined text-3xl align-bottom  self-center"
                (click)="switchAttachmentPanel()">attach_file</span>
              <span
                  [ngClass]="{'text-green-400 cursor-pointer':question.Photos.length>0,'text-grey-500 cursor-not-allowed':question.Photos.length<=0}"
                  class="material-symbols-outlined text-3xl align-bottom  self-center ml-2"
                (click)="switchPhotoPanel()">photo_camera</span>
              <span
                [ngClass]="{'text-green-400 cursor-pointer':allActionsResolved() && question.Actions.length > 0,'text-danger-base cursor-pointer':question.Actions.length>0 && !allActionsResolved(),'text-grey-500 cursor-not-allowed':question.Actions.length<=0}"
                class="material-symbols-outlined text-3xl align-bottom  self-center ml-2"
                (click)="switchActionPanel()">report</span>
              @if (eventId > -1) {
                <button class="btn-inverse btn-compact btn-small ml-2" type="button" (click)="editQuestion()">
                  <i class="pi pi-pencil"></i>
                  <span class="ml-1 text-sm">Edit</span>
                </button>
              }
            </div>
          </div>
          </div>
        </div>
      }
      @if (question.QuestionTypeID == 8) {
        <div class="px-2">
          <div class="flex">
            <p class="text-green-700 mr-2 font-bold">Q</p>
            <div>
              <p class="font-bold">{{question.QuestionHeader}}</p>
            </div>
          </div>
          @if ( question.QuestionResult.length>0 && question.QuestionResult != 'Question Not Answered') {
            <div>
              <img [src]="question.QuestionResult" class="max-h-36" />
            </div>
          }
          @if ( question.QuestionResult=='Question Not Answered') {
            <div>
              <p class="pl-6 pt-2">No signature provided.</p>
            </div>
          }
        </div>
      }
      @if (question.Photos.length>0) {
        <div>
          <div [ngClass]="{'':expandedPhotoPanel,'hidden':!expandedPhotoPanel}"
            class="px-2 mx-5 border-[1px] border-solid border-grey-900 mb-2 rounded-md  print-block print-remove-border print-no-padding">
            <h4 class="mb-4 print-mb-1 mt-2 font-semibold text-green-700">Photos</h4>
            <div class="flex flex-wrap">
              @for (p of question.Photos; track p) {
                <div class=" ml-2 mb-2 print-mb-1 print-ml-1 ">
                  <img [src]="photoSrc(p)" class="max-h-52 print-max-h-40" />
                </div>
              }
            </div>
          </div>
        </div>
      }
      @if (question.QuestionAttachments.length>0) {
        <div>
          <div [ngClass]="{'':expandedAttachmentPanel,'hidden':!expandedAttachmentPanel}"
            class="p-2 mx-5 border-[1px] border-solid border-grey-900 mb-2 rounded-md print-block print-remove-border print-no-padding">
            <h4 class="mb-4 print-mb-1 font-semibold text-green-700">Attachments</h4>
            @for (q of question.QuestionAttachments; track q) {
              <div class="mt-1 print-no-margin flex items-center gap-3">
                @if (isImageAttachment(q)) {
                  <img [src]="attachmentSrc(q.GUID)" alt="Preview" class="attachment-thumb">
                }
                <p class="underline hover:text-green-700 cursor-pointer print-text-decoration-none"
                  (click)="downloadAttachment(q)">
                {{filenameReduction(q.FileName)}}</p>
              </div>
            }
          </div>
        </div>
      }
      @if (question.Actions.length>0) {
        <div>
          <div [ngClass]="{'':expandedActionPanel,'hidden':!expandedActionPanel}"
            class=" md:mx-5 print-mx-5  print-block print-no-break mb-3">
            <h4 class="mb-4 print-mb-1 mt-2 print-mt-1 print-mb-1 font-semibold text-green-700">Actions</h4>
            <table class="w-full table-auto bg-standardwhite border border-grey-900 p-2 print-text-xs overflow-x-auto">
              <thead>
                <tr class="border-b border-green-700">
                  <th class="text-left pl-2 md:w-1/8 "><span class="print-text-xs hidden md:block print-block">Status</span></th>
                  <th class="text-left">Action</th>
                  <th class="text-left md:w-1/8">Due/Resolved</th>
                  <th class="text-left  md:w-1/8 hidden md:block print-block">Assigned To</th>
                  <th class=" md:w-1/6 print-hidden"></th>
                  <!--<th class="hidden md:table-cell">Download</th>-->
                </tr>
              </thead>
              <tbody>
                @for (a of question.Actions; track a) {
                  <tr>
                    <td class="text-left pr-2 pl-2">
                      @if (a.Resolved) {
                        <span class="print-text-xs hidden md:block print-block">Resolved</span>
                      }
                      @if (!a.Resolved) {
                        <span class="print-text-xs hidden md:block print-block">Open</span>
                      }
                      @if (a.Resolved) {
                        <span  class="md:hidden material-symbols-outlined print-hidden">task_alt</span>
                      }
                      @if (!a.Resolved) {
                        <span  class="md:hidden material-symbols-outlined print-hidden"></span>
                      }
                    </td>
                    <td class="text-left"><span class="print-text-xs hidden md:block  print-block">{{a.ActionDescription}}</span><span class="md:hidden print-hidden">{{stringReduction(a.ActionDescription,20)}}</span></td>
                    <td class="text-left" [ngClass]="{'text-danger-base':isPastDate(a.ActionDeadline) && !a.Resolved}">
                      @if (!a.Resolved) {
                        <span class="print-text-xs hidden md:block print-block">{{humanDate(a.ActionDeadline)}}</span>
                        }@if (a.Resolved) {
                        <span class="print-text-xs hidden md:block print-block">{{humanDate(a.ResolvedDate)}}</span>
                      }
                      @if (!a.Resolved) {
                        <span class="print-text-xs md:hidden print-hidden">{{shortDate(a.ActionDeadline)}}</span>
                        }@if (a.Resolved) {
                        <span class="print-text-xs md:hidden  print-hidden">{{shortDate(a.ResolvedDate)}}</span>
                      }
                    </td>
                    <td class="text-left hidden md:table-cell print-table-cell">{{a.AssignedTo}}</td>
                    <!--<td class="p-2 text-center hidden md:table-cell"><button class="btn-primary" (click)="fetchAttachment(a)"><span class="material-symbols-outlined text-xl mr-1 align-bottom text-standardwhite self-center">download</span></button></td>-->
                    <td class="p-2 text-right print-hidden "><span class="underline hover:cursor-pointer hover:text-green-700 print-text-xs hidden md:block"
                      (click)="detailAction(a.ActionID)">View Action</span><span (click)="detailAction(a.ActionID)" class="md:hidden material-symbols-outlined self-center">expand_circle_right</span></td>
                    </tr>
                  }
                </tbody>
              </table>
         
          </div>
        </div>
      }
    </div>
  }
  @if (question.QuestionTypeID==6) {
    <div class="border-t-4 mt-2 pt-2 border-solid border-grey-500">
      <strong>{{question.QuestionHeader}}</strong>
    </div>
  }

</div>
